module.exports = __webpack_public_path__ + "img/avatar1_11zon.fdf72644.webp";